var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.569,
    height: 18.555,
    viewBox: "0 0 18.569 18.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "badge-check_1_",
    "data-name": "badge-check (1)",
    d: "M18.589,9.3A4.081,4.081,0,0,0,17.1,6.1a4.251,4.251,0,0,0-1.231-3.378,4.083,4.083,0,0,0-3.312-1.2A4.241,4.241,0,0,0,6.1,1.494,4.233,4.233,0,0,0,2.726,2.726a4.085,4.085,0,0,0-1.2,3.312A4.241,4.241,0,0,0,1.5,12.49a4.251,4.251,0,0,0,1.231,3.378,4.08,4.08,0,0,0,3.312,1.2,4.241,4.241,0,0,0,6.452.027,4.259,4.259,0,0,0,3.377-1.231,4.085,4.085,0,0,0,1.2-3.312A4.249,4.249,0,0,0,18.589,9.3Zm-5-1.11-3.67,3.537a2.323,2.323,0,0,1-3.275-.01L4.9,10.094A.774.774,0,0,1,5.952,8.959L7.716,10.6a.78.78,0,0,0,1.115.019l3.68-3.547a.775.775,0,0,1,1.076,1.115Z",
    transform: "translate(-0.02 -0.02)",
    fill: "#e3c523"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.54c5cb18fa8f410df184598bceed8b61.svg";
export { ForwardRef as ReactComponent };